import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../../../DataTable';
import Spinner from '../../../Spinner';
import {observable} from 'mobx';

@inject('imageTagStore')
@observer
class ImageTagList extends Component {
  constructor(props) {
    super(props);
    this.handleDelete = this.handleDelete.bind(this);
  }

  @observable images = [];

  // actions = [
  //   { label: 'View', link: '/idaq/imagesource/{id}/devices' },
  // ];

  componentWillMount() {
    const { imageTagStore} = this.props;

      imageTagStore.fetchItems();
  }

  handleDelete(idOrIds) {
    this.props.imageTagStore.removeItems(idOrIds);
  }

  render() {
    const { imageTagStore, main, sidebar } = this.props;
    const { items } = imageTagStore;

    if(imageTagStore.isLoading) return <Spinner/>;

    if(!main || !sidebar) return (
      <div>
        <DataTable
          data={items}
          slug={'idaq/image-tag'}
          columns={[
            { key: 'id', label: 'ID' },
            { key: 'name', label: 'Name' },
            { key: 'description', label: 'Description' },
          ]}
          actions={this.actions}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='image-tag'
        />
        {this.props.children}
      </div>
    );

    return (
      <div className='row'>
        <div className='sidebar'>
          <DataTable
            data={items}
            slug={'idaq/image-tag'}
            columns={[
              { key: 'id', label: 'ID' },
                { key: 'name', label: 'Name' },
                { key: 'description', label: 'Description' },
            ]}
            actions={this.actions}
            caption="Image Tags"
            resource='image-tag'
          />
        </div>
        <div className='main'>{main}</div>
      </div>
    )
  }
}

export default ImageTagList;



// WEBPACK FOOTER //
// ./src/components/IDaq/ImageTags/pages/ImageTagList.js